import 'angular-dynamic-locale';

import { MxLanguage } from './language';
import { I18n } from './mx-internationalization';
import { I18nService } from './i18n.service';
import { i18nFilter } from './mx-i18n';
import { i18nInterceptor } from './i18n.interceptor';
import { initLocalizationTransition } from './i18n.states';

export const i18nModule = angular
	.module('mx.sb.i18n.module', ['tmh.dynamicLocale'])
	.service('mx.internationalization', I18n)
	.service('mx.shell.InternationalizationService', I18nService)
	.factory('mx.sb.i18n.httpInterceptor', i18nInterceptor)
	.value('mx.shell.Language', MxLanguage)
	.filter('mxi18n', i18nFilter)
	.config(i18nModuleConfig)
	.run(i18nModuleRun);

i18nModuleConfig.$inject = ['$transitionsProvider', 'tmhDynamicLocaleProvider'];
function i18nModuleConfig($transitionsProvider, tmhDynamicLocaleProvider) {
	tmhDynamicLocaleProvider.localeLocationPattern('node_modules/angular-i18n/angular-locale_{{locale}}.js?anticache=' + window.mxShellVersion);

	initLocalizationTransition($transitionsProvider);
}

i18nModuleRun.$inject = ['mx.app.HttpInterceptorsRegistry', 'mx.sb.i18n.httpInterceptor'];
function i18nModuleRun(httpInterceptorsRegistry, i18nInterceptor) {
	httpInterceptorsRegistry.register(i18nInterceptor);
}
